import { useParams } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
  getServerErrorText,
} from 'shared/lib';

import { EmptyData, ErrorMessage } from 'shared/ui';

import {
  Group,
  GroupType,
  useGetGroupQuery,
  useCustomUpdateChargePointsGroupMutation,
} from 'entities/group';

import { EDIT_SUCCESS, EDIT_ERROR } from '../consts';
import {
  ChargePointsGroupFormData,
  ConnectedChargePointsGroupForm,
} from 'entities/charge-points-group';

const getInitialValues = (group: Group): ChargePointsGroupFormData => {
  const { parentId, name, tariff } = group;

  return {
    parentId: parentId ? String(parentId) : '',
    name,
    comment: '',
    tariffId: tariff ? String(tariff.id) : '',
  };
};

export function EditChargePointsGroup() {
  // TODO: после доработок привязки тарифов на бэке - поменять
  const [trigger, { isLoading }] = useCustomUpdateChargePointsGroupMutation();

  const { groupId } = useParams() as { groupId: string };

  const { data, isFetching, error } = useGetGroupQuery(groupId);

  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (!data?.group) {
    return <EmptyData />;
  }

  const handleSubmit = async (values: ChargePointsGroupFormData) => {
    const id = String(data.group.id);

    const oldParentId = String(data.group.parentId ? data.group.parentId : '');

    const req = {
      ...values,
      id: Number(id),
      oldParentId,
      groupType: 2 as GroupType,
    };

    try {
      const res = await trigger(req).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);
        return;
      }
      //

      openSuccessNotification(EDIT_SUCCESS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : EDIT_ERROR;

      openErrorNotification(errorText);
    }
  };

  const initialValues = getInitialValues(data.group);

  return (
    <ConnectedChargePointsGroupForm
      title={data.group.name}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
